<template>
  <div class="project-services-wrapper">
    <Banner :bannerImg="Img1"></Banner>

    <!-- 面包屑 -->
    <div class="Crumbs container-fixed">
      <div>
        当前位置：<router-link to="/">首页</router-link> &gt;
        <span>服务项目</span>
      </div>
    </div>

    <main class="main-content">
      <!-- 科技板块 - 介绍 -->
      <section class="intro-section container-fixed">
        <div class="intro-card card-modern">
          <h1 class="section-title">{{ info.serviceInfo.webContentTitle }}</h1>
          <div
            class="intro-text"
            v-html="info.serviceInfo.webContentText"
          ></div>
        </div>
      </section>

      <!-- 服务列表 -->
      <section class="services-list-section">
        <div class="container-fixed">
          <div class="section-header">
            <div class="en-title">OUR SERVICES</div>
            <div class="cn-title">{{ info.title.webContentTitle }}</div>
          </div>

          <div class="services-grid">
            <div
              class="service-horizontal-card card-modern"
              v-for="(item, index) in serviceList"
              :key="index"
              @click="detailList(item.serviceType)"
            >
              <div class="card-image">
                <img :src="item.picLoad" :alt="item.serviceTitle" />
              </div>
              <div class="card-content">
                <h3 class="service-name">{{ item.serviceTitle }}</h3>
                <p class="service-remark">{{ item.remark }}</p>
                <div class="view-more-btn">
                  <span>查看服务列表</span>
                  <i class="el-icon-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Banner from "../components/banner.vue";
import article from "@/api/article";

export default {
  name: "ProjectServices",
  components: {
    Banner,
  },
  data() {
    return {
      Img1: require("../assets/images/newsbanner.jpg"),
      info: {
        title: { webContentText: "", webContentTitle: "" },
        serviceInfo: { webContentText: "", webContentTitle: "" },
      },
      serviceList: [],
    };
  },
  mounted() {
    this.handleGetData();
    this.serviceData();
  },
  methods: {
    serviceData() {
      article
        .serviceList()
        .then((res) => {
          this.serviceList = res.data.data.records;
        })
        .catch((err) => console.error(err));
    },
    handleGetData() {
      article
        .aboutData({ belongPage: "project" })
        .then((res) => {
          const records = res.data.data.records;
          records.forEach((item) => {
            this.info[item.notes] = item;
          });
        })
        .catch((err) => console.error(err));
    },
    detailList(serviceType) {
      this.$router.push({
        path: "/projectlist",
        query: { serviceType },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/styles/variables.less";

.project-services-wrapper {
  background-color: @bg-base;
}

.Crumbs {
  padding: 20px 0;
  font-size: 14px;
  color: @text-secondary;
  span {
    color: @text-main;
    font-weight: 500;
  }
  a:hover {
    color: @primary-color;
  }
}

.main-content {
  padding-bottom: 80px;
}

/* 介绍板块 */
.intro-section {
  margin-bottom: 60px;
}

.intro-card {
  padding: 60px @space-xxl;
  text-align: center;
  background-color: #ffffff;

  .section-title {
    font-size: 32px;
    font-weight: 700;
    color: @primary-color;
    margin-bottom: 32px;
    position: relative;
    display: inline-block;

    &::after {
      content: "";
      position: absolute;
      bottom: -12px;
      left: 50%;
      transform: translateX(-50%);
      width: 60px;
      height: 4px;
      background: @primary-color;
      border-radius: 2px;
    }
  }

  .intro-text {
    font-size: 16px;
    line-height: 2;
    color: @text-secondary;
    max-width: 1000px;
    margin: 0 auto;
    text-align: justify;
    text-indent: 2em;
  }
}

/* 服务列表 */
.services-list-section {
  padding: 60px 0;
}

.services-grid {
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-top: 40px;
}

.service-horizontal-card {
  display: flex;
  height: 360px;
  overflow: hidden;
  cursor: pointer;

  .card-image {
    width: 480px;
    flex-shrink: 0;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    }
  }

  .card-content {
    flex: 1;
    padding: 60px 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: #ffffff;

    .service-name {
      font-size: 28px;
      font-weight: 700;
      color: @text-main;
      margin-bottom: 24px;
      transition: color 0.3s;
    }

    .service-remark {
      font-size: 15px;
      line-height: 1.8;
      color: @text-secondary;
      margin-bottom: 32px;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .view-more-btn {
      display: flex;
      align-items: center;
      gap: 12px;
      font-size: 15px;
      font-weight: 600;
      color: @primary-color;
      transition: all 0.3s;

      i {
        font-size: 18px;
        transition: transform 0.3s;
      }
    }
  }

  &:hover {
    .card-image img {
      transform: scale(1.08);
    }
    .card-content {
      .service-name {
        color: @primary-color;
      }
      .view-more-btn {
        gap: 20px;
        i {
          transform: translateX(8px);
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .service-horizontal-card {
    height: auto;
    flex-direction: column;
    .card-image {
      width: 100%;
      height: 280px;
    }
    .card-content {
      padding: 40px;
    }
  }
}
</style>
